
import joombooking from "../images/joombooking.png";
import nhaphovietnam from "../images/nhaphovietnam.png";
import ExperienceBox from "./ExperienceBox";
import GKCorp from "../images/gkcorp_logo.jpg";

const Experiences = () => {
  return (
    <div>
      <h1 className="projectHeading">
        My <b>Experiences</b>
      </h1>
      <div className="project">
        <ExperienceBox projectPhoto={joombooking} projectName="Joombooking" />
        <ExperienceBox projectPhoto={nhaphovietnam} projectName="NhaphoVN" />
        <ExperienceBox projectPhoto={GKCorp} projectName="GKCorp" />
      </div>
    </div>
  );
};

export default Experiences;
